import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, Input } from "antd";
import { useState } from "react";
import { useI18n } from "../../../../../contexts/i18n.js";
import { FormValueDifferFromTemplateTag } from "../../../valueDifferFromTemplateTag.js";
const FormServiceFieldGeneralProviderLegalNoticeUrl = ()=>{
    const { __ } = useI18n();
    const [ref, setRef] = useState();
    return /*#__PURE__*/ _jsx(Form.Item, {
        noStyle: true,
        shouldUpdate: (prevValues, nextValues)=>prevValues.isProviderCurrentWebsite !== nextValues.isProviderCurrentWebsite,
        children: ({ getFieldValue })=>/*#__PURE__*/ _jsxs(Form.Item, {
                label: __("Legal notice of the provider"),
                style: {
                    display: getFieldValue("isProviderCurrentWebsite") ? "none" : undefined
                },
                children: [
                    /*#__PURE__*/ _jsx(Form.Item, {
                        name: "providerLegalNoticeUrl",
                        noStyle: true,
                        rules: [
                            {
                                type: "url",
                                message: __("Please provide a valid URL!")
                            }
                        ],
                        children: /*#__PURE__*/ _jsx(Input, {})
                    }),
                    /*#__PURE__*/ _jsxs("p", {
                        className: "description",
                        ref: setRef,
                        children: [
                            /*#__PURE__*/ _jsx(FormValueDifferFromTemplateTag, {
                                form: "service",
                                valueName: "providerLegalNoticeUrl",
                                widthOfRef: ref,
                                ignoreEmptyDefaultValue: true,
                                renderDiff: (value)=>/*#__PURE__*/ _jsx(Input, {
                                        value: value,
                                        readOnly: true
                                    })
                            }),
                            __("Provide a direct link to the legal notice or contact of the provider who operates this service (in the language of your website).")
                        ]
                    })
                ]
            })
    });
};
export { FormServiceFieldGeneralProviderLegalNoticeUrl };
